import { TextField } from "@mui/material";
import React from "react";

const RejectMessage = ({ commentInput, handleCommentInput }) => {
  return (
    <div>
      <p>Please enter a reason for rejection</p>
      <TextField
        label="Reject Reason"
        multiline
        maxRows={5}
        value={commentInput}
        onChange={handleCommentInput}
        sx={{
          "& .MuiOutlinedInput-root": {
            color: "#000",
            "&.Mui-focused": {
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--main-theme-color) !important",
              },
            },
          },
          "& .MuiInputLabel-outlined": {
            "&.Mui-focused": {
              color: "var(--main-theme-color) !important",
            },
          },
        }}
      />
    </div>
  );
};

export default RejectMessage;
